module.exports = __webpack_public_path__ + "static/img/Downloader.la-664234ed94f66.2f024f3a.jpg";